module.exports = __webpack_public_path__ + "img/beiyong.5079784c.png";